
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 8.8H7a.4.4 0 100 .8h10a.4.4 0 100-.8z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M7 6.4h4a.4.4 0 100-.8H7a.4.4 0 100 .8z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M17 12H7a.4.4 0 100 .8h10a.4.4 0 100-.8zM17 15.2H7a.4.4 0 100 .8h10a.4.4 0 100-.8zM17 18.4H7a.4.4 0 100 .8h10a.4.4 0 100-.8z","fill":"#00003C"}}),_c('path',{attrs:{"d":"M15.566 0H2.6v24h18.8V5.834L15.566 0zm.234 1.366L20.034 5.6H15.8V1.366zM3.4 23.2V.8H15v5.6h5.6v16.8H3.4z","fill":"#00003C"}})])
          )
        }
      }
    